// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2qgoS","savePackageButton":"ClientWallet_savePackageButton__Tw7Cq"};